// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"df817241e9ec5684f652","293":"af85b3c95da932e6c7ba","461":"0ba88bbb8a7d26c54136","518":"275998b8b3faabbb9bec","779":"40bf706ce189344530d3"}[chunkId] + ".js";
};